<template>
  <v-card
    height="100%"
    class="flex d-flex flex-column"
    style="border-width: 0"
  >
    <v-card-title class="primary white--text py-2 justify-space-between">
      <div>
        {{ $t('detail.employee_info') }}
      </div>
    </v-card-title>
    <v-card-text class="pb-1">
      <v-form ref="addUser">
        <v-row class="ma-0 pt-3">
          <v-col
            cols="6"
            class="py-0"
          >
            ID:
          </v-col>
          <v-col
            cols="6"
            class="py-1"
          >
            <v-skeleton-loader
              v-if="loading"
              width="50%"
              type="text"
            />
            <div
              v-else
              class="primary--text"
            >
              {{ employee.id }}
            </div>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="py-1"
          >
            {{ $t('employee.name') }}:
          </v-col>
          <v-col
            cols="6"
            class="py-1"
          >
            <v-skeleton-loader
              v-if="loading"
              width="50%"
              type="text"
            />
            <div
              v-else
              class="primary--text"
            >
              {{ employee.name }}
            </div>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="py-1"
          >
            {{ $t('common.activation') }}:
          </v-col>
          <v-col
            cols="6"
            class="py-1"
            align-self="center"
          >
            <v-skeleton-loader
              v-if="loading"
              width="50%"
              type="text"
            />
            <v-switch
              v-else
              v-model="active"
              class="mt-0 pt-0"
              :disabled="!active && remainingView === 0"
              hide-details
              @change="onActivate"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  props: {
    employee: {
      type: Object,
      required: true,
    },
    remainingView: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      active: this.employee.active,
    }
  },

  computed: {
    selectionRule() {
      return [
        v => !!v || this.$t('common.required')
      ]
    }
  },

  watch: {
    employee() {
      this.active = this.employee.active
    },
  },

  methods: {
    onActivate() {
      this.$emit('toggled', this.active)
    },
  }
}
</script>

<style scoped>
</style>
